module.exports = __webpack_public_path__ + "img/uncondtional_off_active.5482a303.svg";